import React from 'react';
import { LAST_UPDATED_DATE, LEGAL_TODOS } from './legalPlaceholders';

const CookiePolicy = () => (
  <main className="legal-page">
    <h1>Cookie Policy</h1>
    <p>
      <strong>Last updated:</strong> {LAST_UPDATED_DATE}
    </p>
    <p>
      This Cookie Policy explains how 101Setups uses cookies and similar technologies, including browser local storage,
      when you visit or use the website.
    </p>

    <h2>1. What are cookies and similar technologies?</h2>
    <p>
      Cookies are small text files stored on your device by your browser. Similar technologies include browser local
      storage, session storage, software development kits, and similar identifiers that help websites function,
      remember choices, measure usage, or improve performance.
    </p>

    <h2>2. How 101Setups uses these technologies</h2>
    <p>101Setups uses:</p>
    <ul>
      <li>
        strictly necessary technologies required to operate the website, support login and security features, remember
        technical preferences, and keep the service functioning properly; and
      </li>
      <li>optional analytics technologies that are activated only if you choose to accept them.</li>
    </ul>

    <h2>3. Technologies currently used</h2>
    <p>
      <strong>A. Strictly necessary / preference technologies</strong>
    </p>
    <ul>
      <li>
        <strong>analytics-consent</strong>
        <br />
        Provider: 101Setups
        <br />
        Type: browser local storage
        <br />
        Purpose: stores whether you accepted or rejected optional analytics so the site can respect your choice.
        <br />
        Duration: until you change or clear it.
      </li>
      <li>
        <strong>Authentication and session storage used by AWS Amplify / Amazon Cognito</strong>
        <br />
        Provider: Amazon Web Services
        <br />
        Type: browser local storage and/or session-related storage, and related technical identifiers
        <br />
        Purpose: sign-in, account session handling, security, and operation of authenticated features.
        <br />
        Duration: session-based and/or until expiry, sign-out, or deletion by the browser or user.
      </li>
      <li>
        <strong>Additional technical browser storage used by the web application framework and infrastructure services</strong>
        <br />
        Provider: 101Setups and infrastructure providers
        <br />
        Type: browser storage
        <br />
        Purpose: core site functionality, technical stability, and operation of the web application.
        <br />
        Duration: varies according to the technical function and browser behaviour.
      </li>
    </ul>
    <p>
      <strong>B. Optional analytics technologies — only if you consent</strong>
    </p>
    <ul>
      <li>
        <strong>Google Analytics 4 identifiers</strong>, which may include cookies such as <code>_ga</code> and related
        Google Analytics cookies or similar identifiers.
        <br />
        Provider: Google
        <br />
        Type: cookies and/or similar analytics identifiers
        <br />
        Purpose: measure visits, page views, and general site usage so we can understand and improve the service.
        <br />
        Duration: according to Google&apos;s configuration and your browser settings.
      </li>
    </ul>
    <p>If you reject analytics, optional Google Analytics tracking is not activated.</p>

    <h2>4. Legal basis</h2>
    <p>
      Strictly necessary technologies are used because they are required for the technical operation, security, and
      compliance functioning of the website. Optional analytics technologies are used only with your consent.
    </p>

    <h2>5. How to manage your choices</h2>
    <p>
      When you first visit 101Setups, you can accept or reject optional analytics. Your choice is stored in your
      browser so the site can remember it.
    </p>
    <p>
      You can also manage cookies and similar technologies through your browser settings, including by blocking or
      deleting cookies and local storage for 101Setups. Please note that blocking strictly necessary technologies may
      affect the proper functioning of the site or prevent login and account features from working correctly.
    </p>
    <p>
      Use the footer links for <strong>Cookie settings</strong> or <strong>Reset choice</strong> if you want to reopen
      or clear your analytics choice directly from the site.
    </p>

    <h2>6. Third-party services</h2>
    <p>
      Where optional analytics is enabled, Google may receive information generated by analytics technologies. If you
      click third-party links, including affiliate links, those third parties may place their own cookies or similar
      technologies under their own policies.
    </p>

    <h2>7. Changes to this Cookie Policy</h2>
    <p>
      We may update this Cookie Policy from time to time to reflect legal, technical, or operational changes. The
      version published on this page is the one currently in force.
    </p>

    <h2>8. Contact</h2>
    <p>If you have questions about this Cookie Policy, contact us at {LEGAL_TODOS.legalContactEmail}.</p>
  </main>
);

export default CookiePolicy;
